module.exports = __webpack_public_path__ + "img/sent.34c01262.svg";